/**
 * Created by Jan Bradac on 1.7.2016.
 */

(function (Lfl, $, undefined) {
    (function (Forms, $, undefined) {
        if(Lfl.Files.isLoadedAlready(Lfl.Forms, 'Inputs')) {
            return;
        }

        /*
         |==============================================================================================================
         | Documentation
         |==============================================================================================================
         */

        /**
         * Object responsible for inputs manipulation inside forms
         *
         * @memberOf Lfl.Forms
         */
        Lfl.Forms.Inputs;

        (function (Inputs, $, undefined) {
            /*
            |===========================================================================================================
            | Object definition
            |===========================================================================================================
            */

            /*
            |-----------------------------------------------------------------------------------------------------------
            | Public methods
            |-----------------------------------------------------------------------------------------------------------
            */

            /**
             * Adds a hidden input field to a given form.
             * @memberOf Lfl.Forms.Inputs
             *
             * @param theForm The form which the input should be added to. Not a jQuery object!
             * @param name The name of the input.
             * @param value The value assigned to this input.
             */
            Inputs.addHidden = function (theForm, name, value) {
                // Create a hidden input element, and append it to the form:
                var input = document.createElement('input');
                input.type = 'hidden';
                input.name = name;
                input.value = value;
                theForm.appendChild(input);
            };

            /*
            |-----------------------------------------------------------------------------------------------------------
            | Private methods
            |-----------------------------------------------------------------------------------------------------------
            */
        }(Forms.Inputs = Forms.Inputs || {}, jQuery));
    }(Lfl.Forms = Lfl.Forms || {}, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));